import { CHAIN_CONFIGS, EChainType } from '@/constants/chains'
import { IToken } from '@/types/token.type'
import { SUPPORTED_NETWORK } from '@/utils/constants'

export const isEvmChain = (network: SUPPORTED_NETWORK | string | undefined) => {
  return CHAIN_CONFIGS[network as SUPPORTED_NETWORK]?.type === EChainType.EVM
}

export const isSolanaChain = (network: SUPPORTED_NETWORK | string | undefined) => {
  return CHAIN_CONFIGS[network as SUPPORTED_NETWORK]?.type === EChainType.SOLANA
}

export const isBtcChain = (network: SUPPORTED_NETWORK | string | undefined) => {
  return CHAIN_CONFIGS[network as SUPPORTED_NETWORK]?.type === EChainType.BTC
}

export const isChainSupportKit = (networkId: string | undefined) => isEvmChain(networkId) || isSolanaChain(networkId)

export const getNetworkName = (toToken: IToken | null) => {
  return isEvmChain(toToken?.networkId) ? 'EVM' : toToken?.networkName
}
